import Flickity from "../../node_modules/flickity-fade";

document.addEventListener("alpine:init", () => {
    Alpine.data("imageCarousel", (autoplay) => ({
        slider: null,
        sliderContainer: null,
        currentIndex: 0,
        isAnimating: false,
        sliderEnd: false,
        autoplay: autoplay || 5,
        init() {
            this.sliderContainer = this.$refs.slider;
            const slides = this.sliderContainer.querySelectorAll(
                ".Image__Carousel-slide"
            );

            this.slider = new Flickity(this.sliderContainer, {
                cellAlign: "left",
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
                freeScroll: false,
                fade: true,
                pauseAutoPlayOnHover: false,
                autoPlay: this.autoplay * 1000,
                on: {
                    settle: () => {
                        this.currentIndex = this.slider.selectedIndex;
                    },
                    ready: () => {
                        window.dispatchEvent(new Event("resize"));
                        //this.sliderResize();
                    },
                    change: (index) => this.changeSlide(index),
                },
            });

            this.currentIndex = this.slider.selectedIndex;

            this.slider.on("change", () => {
                this.updateTabIndexes(slides);
                this.updateSliderEnd();
            });

            //pegasus.onResizeFinished(() => {
            //    this.sliderResize();
            //}, false);

            this.updateTabIndexes(slides);
            this.updateSliderEnd();
        },
        sliderResize() {
            const flickitySliders = document.querySelectorAll(
                ".Image__Carousel .flickity-slider"
            );

            this.sliderFullWidth = 0;

            flickitySliders.forEach((slider) => {
                const slides = slider.querySelectorAll(
                    ".Image__Carousel-slide"
                );
                let height = 0;

                slides.forEach((slide) => {
                    slide.style.height = "";
                    this.sliderFullWidth += slide.offsetWidth;
                    if (slide.offsetHeight > height) {
                        height = slide.offsetHeight;
                    }
                });

                slides.forEach((slide) => {
                    slide.style.height = height + "px";
                });

                slider.style.height = "";
                slider.style.height = height + "px";
            });
        },

        previousSlide() {
            if (window.innerWidth >= 768) {
                this.isAnimating = true;
            }
            this.slider.previous();
            setTimeout(() => {
                this.isAnimating = false;
            }, 700);
        },
        nextSlide() {
            if (window.innerWidth >= 768) {
                this.isAnimating = true;
            }
            this.slider.next();
            setTimeout(() => {
                this.isAnimating = false;
            }, 700);
        },
        changeSlide(index) {
            if (window.innerWidth >= 768) {
                this.isAnimating = true;
            }
            this.currentIndex = index;
            setTimeout(() => {
                this.isAnimating = false;
            }, 700);
        },
        /**
         * updateTabIndexes
         *
         * Description: Updates the tabindexes of the slides this is required for accessibility.
         * Inactive slides shouldn't be accessible via the keyboard.
         *
         * @param {} slides
         */
        updateTabIndexes(slides) {
            slides.forEach((slide) => {
                const slideElements = slide.querySelectorAll("a, button");

                slideElements.forEach((element) => {
                    if (slide.classList.contains("is-selected")) {
                        element.removeAttribute("tabindex");
                    } else {
                        element.setAttribute("tabindex", "-1");
                    }
                });
            });
        },

        /**
         * updateSliderEnd
         *
         * Description: Updates sliderEnd property based on whether the slider is at the end or not.
         */
        updateSliderEnd() {
            const selectedIndex = this.slider.selectedIndex;
            const slideCount = this.slider.slides.length;
            this.sliderEnd = selectedIndex === slideCount - 1;
        },
    }));
});
